import SetPassword from './SetPassword';
import { useDispatch, useSelector } from 'react-redux';
import FJAction from '../../action/FJAction';
import { useEffect } from 'react';
import FJCaptcha from '../../store/FJCaptcha';

let SetPasswordContainer = props => {
    let { popupType, stepChange } = props;
    const dispatch = useDispatch();
    const { email, registerPassword, code, page, method } = useSelector(store => {
        return {
            email: store.mainStore.email,
            registerPassword: store.mainStore.registerPassword,
            code: store.mainStore.registerCode,
            page: store.mainStore.page,
            method: store.mainStore.method,
        };
    });
    // 改变注册密码
    let _changeRegisterPassword = pw => {
        dispatch(FJAction.changeRegisterPasswordAction(pw));
    };
    // 邮箱注册
    let _emailRegister = (password, callBack) => {
        dispatch(FJAction.emailRegister({ email: email, password: password, verify_code: code }, callBack));
    };

    useEffect(() => {
        if (!FJCaptcha.getApiIsApiLoading() && !FJCaptcha.getApiIsLoaded()) {
            // 接受了cookie，就允许第三方cookie加载（flexclip应对谷歌检查需求， 2024.3.1）
            if (localStorage.getItem("cookie_privacy_shown") !== "2") {
                dispatch(FJAction.loadCaptchaApi());
            }
        }
    }, []);

    return (
        <SetPassword
            email={email}
            password={registerPassword}
            passwordChange={_changeRegisterPassword}
            stepChange={stepChange}
            emailRegister={_emailRegister}
            popupType={popupType}
            active={true}
            page={page}
            method={method}
        />
    );
};

export default SetPasswordContainer;
